import React, { useEffect, useState } from 'react';
import Base from '../Base';
import Title from '../../components/common/Title';
import BadgeSheet, { BadgeTile } from '../../components/common/BadgeSheet';
import { useTranslation } from 'react-i18next';
import { apiRequest } from '../../utils';
import './PublicProfile.css';

/* The badges a person earned, and the next rung of each ladder.

   Badges are granted at night (shared_models/services/badges) and kept for life. Progress is a
   number only for COUNTS ("3 of 5"): a badge on the engagement score shows no number, because the
   score itself is the admin's and not the employee's — see queries/badges in the API. */

const yearOf = (iso) => (iso ? String(iso).slice(0, 4) : '');

const Page = () => {
  const { t } = useTranslation('common');
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    let active = true;
    apiRequest('GET', '/my-badges')
      .then((res) => { if (active) setData(res); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, []);

  const earned = data?.badges || [];
  const next = data?.next || [];

  return (
    <Base activeNav="user">
      <Title>{t('badges')}</Title>
      <div className="pp-page">
        {failed && <p className="text-muted">{t('somethingWentWrong')}</p>}

        {data && (
          <section className="pp-section">
            <header className="pp-section-header">
              <h2 className="pp-section-title">{t('badgesEarned')}</h2>
              <span className="pp-section-count">{earned.length}</span>
            </header>
            {earned.length === 0 ? (
              <p className="text-muted">{t('badgesEmpty')}</p>
            ) : (
              <div className="pp-awards-grid">
                {earned.map((b) => (
                  <BadgeTile key={b.id} badge={b} onOpen={setOpen}>
                    {yearOf(b.awarded_on) && <div className="pp-award-event">{yearOf(b.awarded_on)}</div>}
                  </BadgeTile>
                ))}
              </div>
            )}
          </section>
        )}

        {next.length > 0 && (
          <section className="pp-section">
            <header className="pp-section-header">
              <h2 className="pp-section-title">{t('badgesNext')}</h2>
            </header>
            <div className="pp-awards-grid">
              {next.map((b) => {
                const counted = b.current !== null && b.current !== undefined && b.threshold;
                const pct = counted ? Math.min(100, Math.round((100 * b.current) / b.threshold)) : 0;
                return (
                  <BadgeTile key={b.id} badge={b} onOpen={setOpen} muted>
                    {counted ? (
                      <>
                        <div className="progress mt-1" style={{ height: 4 }}>
                          <div className="progress-bar" style={{ width: `${pct}%` }} />
                        </div>
                        <div className="pp-award-event">
                          {t('badgeProgress', { current: b.current, threshold: b.threshold })}
                        </div>
                      </>
                    ) : (
                      <div className="pp-award-event">{t('badgeKeepGoing')}</div>
                    )}
                  </BadgeTile>
                );
              })}
            </div>
          </section>
        )}
      </div>
      <BadgeSheet badge={open} onClose={() => setOpen(null)} />
    </Base>
  );
};

export default Page;
